import { defineMessages } from 'react-intl';

/**
 * Will have the messages displayed in the ManageAffordableWaitlistV2 component
 */
const messages = defineMessages({
  title: {
    id: 'App.ManageAffordableWaitlistV2.Title',
    defaultMessage: 'Manage Affordable Waitlist',
  },
  bedroomTabLabel: {
    id: 'App.ManageAffordableWaitlistV2.BedroomTabLabel',
    defaultMessage: '{count} Bedroom',
  },
  position: {
    id: 'App.ManageAffordableWaitlistV2.Position',
    defaultMessage: 'Waitlist Position',
  },
  preferenceWeight: {
    id: 'App.ManageAffordableWaitlistV2.PreferenceWeight',
    defaultMessage: 'Preference Weight',
  },
  submissionDateTime: {
    id: 'App.ManageAffordableWaitlistV2.SubmissionDateTime',
    defaultMessage: 'Submission Date/Time',
  },
  affordableProgram: {
    id: 'App.ManageAffordableWaitlistV2.AffordableProgram',
    defaultMessage: 'Affordable Program',
  },
  applicationCode: {
    id: 'App.ManageAffordableWaitlistV2.ApplicationCode',
    defaultMessage: 'Application Code',
  },
  applicants: {
    id: 'App.ManageAffordableWaitlistV2.Applicants',
    defaultMessage: 'Applicant',
  },
  texting: {
    id: 'App.ManageAffordableWaitlistV2.Texting',
    defaultMessage: 'Texting',
  },
  householdStatus: {
    id: 'App.ManageAffordableWaitlistV2.HouseholdStatus',
    defaultMessage: 'Household Status',
  },
  status: {
    id: 'App.ManageAffordableWaitlistV2.Status',
    defaultMessage: 'Status',
  },
  phoneNumber: {
    id: 'App.ManageAffordableWaitlistV2.PhoneNumber',
    defaultMessage: 'Phone Number',
  },
  emailAddress: {
    id: 'App.ManageAffordableWaitlistV2.EmailAddress',
    defaultMessage: 'Email',
  },
  desiredMoveInDate: {
    id: 'App.ManageAffordableWaitlistV2.DesiredMoveInDate',
    defaultMessage: 'Desired Move-In Date',
  },
  applicationReceived: {
    id: 'App.ManageAffordableWaitlistV2.ApplicationReceived',
    defaultMessage: 'Date And Time Received',
  },
  applicationRemoved: {
    id: 'App.ManageAffordableWaitlistV2.ApplicationRemoved',
    defaultMessage: 'Date And Time Removed',
  },
  preferredUnitSize: {
    id: 'App.ManageAffordableWaitlistV2.PreferredUnitSize',
    defaultMessage: 'Preferred Unit Size',
  },
  householdSize: {
    id: 'App.ManageAffordableWaitlistV2.HouseholdSize',
    defaultMessage: 'Household Size',
  },
  incomeLevel: {
    id: 'App.ManageAffordableWaitlistV2.IncomeLevel',
    defaultMessage: 'Income Level',
  },
  datesContacted: {
    id: 'App.ManageAffordableWaitlistV2.DatesContacted',
    defaultMessage: 'Dates Contacted',
  },
  moveInDate: {
    id: 'App.ManageAffordableWaitlistV2.MoveInDate',
    defaultMessage: 'Move-In Date',
  },
  needsUnitAccessible: {
    id: 'App.ManageAffordableWaitlistV2.NeedsUnitAccessible',
    defaultMessage: 'Need for Accessible Unit',
  },
  requestingAccommodation: {
    id: 'App.ManageAffordableWaitlistV2.RequestingAccommodation',
    defaultMessage: 'Accommodations Requested',
  },
  preferences: {
    id: 'App.ManageAffordableWaitlistV2.Preferences',
    defaultMessage: 'Preferences',
  },
  assignedTo: {
    id: 'App.ManageAffordableWaitlistV2.AssignedTo',
    defaultMessage: 'Assigned To',
  },
  selectFromWaitlist: {
    id: 'App.ManageAffordableWaitlistV2.Actions.SelectFromWaitlist',
    defaultMessage: 'Select From Waitlist',
  },
  deny: {
    id: 'App.ManageAffordableWaitlistV2.Actions.Deny',
    defaultMessage: 'Deny',
  },
  cancel: {
    id: 'App.ManageAffordableWaitlistV2.Actions.Cancel',
    defaultMessage: 'Cancel',
  },
  reinstate: {
    id: 'App.ManageAffordableWaitlistV2.Actions.Reinstate',
    defaultMessage: 'Reinstate',
  },
  actions: {
    id: 'App.ManageAffordableWaitlistV2.Actions',
    defaultMessage: 'Actions',
  },
  generateReport: {
    id: 'App.ManageAffordableWaitlistV2.GenerateReport',
    defaultMessage: 'Generate Waitlist Report',
  },
  includeAll: {
    id: 'App.ManageAffordableWaitlistV2.IncludeAll',
    defaultMessage: 'Include All',
  },
});

export default messages;
